export default {
  // 模块名称
  workOrder: {
    // 按钮类
    button: {
      add: 'Add',
      batchDel: 'Batch delete',
      reset: 'Reset',
      query: 'Query',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      confirm: 'Confirm',
      setPermission: 'Permission settings',
      relation: 'Account associated',
      back: 'Back'
    },
    // 文字标签类
    label: {
      templateName: 'TemplateName',
      fileUpload: 'FileUpload',
      createTime: 'CreateTime',
      editTable: 'EditTable',
      deleteTable: 'DeleteTable',
      editFlow: 'EditFlow',
    },
    // 提示类
    placeholder: {
      templateName: 'Please input templateName',
      fileUpload: 'Please upload image'
    },
    // 消息类
    message: {
      deltips: 'This will permanently delete the selected template. continue?',
    },
    // 标题类
    title: {
      warn: 'Warning',
      fields: 'Edit fields',
      createTable: 'CreateTable',
      createFlow: 'CreateFlow',
      addColumn: 'AddColumn',
      dataColumn: 'DataColumn',
      column: 'Column',
      create: 'Create'
    }
  }
}